import React from "react";
import "./style.scss";
import { FormatUSD } from "../../../utils/helpers/string";

function AccountsData({ data }) {
  const newData = data?.account_metrics?.calculated_data;

  const accountData1 = [
    { title: "Daily Gain", customClass: true, value: newData?.daily_gain?.toFixed(2) },
    { title: "Abs Gain", customClass: true, value: newData?.absolute_gain?.toFixed(2) },
    { title: "RRR", customClass: false, value: newData?.average_rrr?.toFixed(2) },
    { title: "Expectancy", customClass: false, value: newData?.expectancy_ratio?.toFixed(2) },
    { title: "Best Trade", value: newData?.highest?.toFixed(2), formatUsd: true },
    { title: "Worst Trade", value: newData?.worst_trade?.toFixed(2), formatUsd: true },
    { title: "Avg Win", value: newData?.average_profit?.toFixed(2), formatUsd: true },
  ];

  const accountData2 = [
    { title: "Avg Loss", value: newData?.average_loss?.toFixed(2), formatUsd: true },
    { title: "No of Trades", value: newData?.total_trades ?? "N/A", formatUsd: false },
    { title: "Win Rate", value: newData?.win_rate?.toFixed(2), formatUsd: false },
    { title: "Contracts", value: newData?.lots ?? "N/A", formatUsd: false },
    { title: "Profit Factor", value: newData?.profit_factor?.toFixed(2) ?? "N/A", formatUsd: false },
    ...(data?.next_payout_date
      ? [{ title: "Next Payout Date", customClass: true, value: data.next_payout_date }]
      : []),
  ];

  return (
    <div className="account-data box">
      <h2 className="component-heading">Statistics</h2>
      <div className="account-data-box-wrapper">
        {accountData1.map((item, index) => (
          <AccountDataBox key={`${item.title}-${index}`} data={item} />
        ))}
      </div>
      <div className="account-data-box-wrapper">
        {accountData2.map((item, index) => (
          <AccountDataBox key={`${item.title}-${index}`} data={item} />
        ))}
      </div>
    </div>
  );
}

const AccountDataBox = ({ data }) => {
  const { title, value, formatUsd } = data;
  const isSpecialField = ["RRR", "Expectancy", "Next Payout Date", "No of Trades", "Contracts", "Profit Factor"].includes(title);
  const formattedValue = value ?? "N/A";

  return (
    <div className={`account-data-box ${data.customClass ? "custom" : ""}`}>
      <div className="account-data-left">
        <p>{title}</p>
      </div>
      <div className="account-data-right">
        <span
          style={{
            color:
              !isSpecialField && formattedValue !== "N/A"
                ? Number(formattedValue) > 0
                  ? "#7ad67a"
                  : Number(formattedValue) < 0
                    ? "#ff4343"
                    : ""
                : "",
          }}
        >
          {isSpecialField || formattedValue === "N/A"
            ? formattedValue
            : formatUsd
              ? FormatUSD(formattedValue)
              : `${formattedValue}%`}
        </span>
      </div>
    </div>
  );
};

export default AccountsData;